import { Platform } from 'react-native';
import _ from 'lodash';

import * as modules from '../modules';
import Utils from './Utils';
import APIClient from './APIClient';

const ADMIN_ROLE = 'admin';
const AGENCY_ROLE = 'agency';
const PARTNER_ROLE = 'partner';
const SALESMAN_ROLE = 'salesman';
const MARKETER_ROLE = 'marketer';

export default class UserUtils {

  static isSignedIn (user) {
    if (!user) {
      return;
    }
    const {credential, info} = user;
    return !_.isEmpty(credential)
      && !_.isEmpty(credential.username)
      && !_.isEmpty(credential.password)
      && !_.isEmpty(info);
  }

  static isAdmin = (user) => {
    return user && user.info && user.info.role === ADMIN_ROLE;
  };

  static isAgency = (user) => {
    return user && user.info && user.info.role === AGENCY_ROLE;
  };

  static isPartner = (user) => {
    return user && user.info && user.info.role === PARTNER_ROLE;
  };

  static isSeller = (user) => {
    return user && user.info
      && (user.info.role === AGENCY_ROLE
        || user.info.role === PARTNER_ROLE);
  };

  static isSalesman = (user) => {
    return user && user.info && user.info.role === SALESMAN_ROLE;
  };

  static isMarketer = (user) => {
    return user && user.info && user.info.role === MARKETER_ROLE;
  };

  static isValidCredential = (credential) => {
    return credential && !_.isEmpty(credential.username) &&
      !_.isEmpty(credential.password);
  };

  /**
   * update fcm token
   *
   * @param credential credential of user
   * @param fcmToken fcm token
   */
  static updateFCMToken (credential, fcmToken) {
    if (Platform.OS === 'web') {
      return;
    }

    if (!UserUtils.isValidCredential(credential)
      || _.isEmpty(fcmToken)) {
      return;
    }

    UserUtils._doUpdateFCMToken(1, credential, fcmToken);
  }

  /**
   * sign out
   *
   * @param credential credential of user
   * @param fcmToken fcm token
   */
  static signOut (credential, fcmToken) {
    UserUtils._doSignOut(1, credential, fcmToken);
  }

  /**
   * reset notification count for user
   *
   * @param credential credential of user
   */
  static resetNotificationCount (credential) {
    if (Platform.OS === 'web') {
      return;
    }

    if (!UserUtils.isValidCredential(credential)) {
      return;
    }
    UserUtils._doResetNotificationCount(1, credential);
  }

  /**
   *
   */
  static _doUpdateFCMToken (attempts, credential, token) {
    if (attempts > 3) {
      console.log('too much attempts to update fcm token');
      return;
    }

    console.log('try to update fcm token to server');
    const url = APIClient.BASE_API_URL + '/user/updateFCMToken';
    console.log('url: ' + url);
    const headers = Utils.createBasicAuthHeaders(credential);
    const params = {
      token: token,
    };
    fetch(url, {
      method: 'POST',
      headers: headers,
      body: Utils.createBodyParams(params),
    }).then((response) => response.json()).then((json) => {
      UserUtils._handleFCMTokenNetworkResponse(attempts, credential, token,
        json, null);
    }).catch((error) => {
      UserUtils._handleFCMTokenNetworkResponse(attempts, credential, token,
        null, error);
    });
  }

  static _handleFCMTokenNetworkResponse (
    attempts, credential, token, response, error) {
    if (response && response.response) {
      // update fcm token successfully
      console.log('update fcm token to server successfully');
    } else {
      // try again
      this._doUpdateFCMToken(attempts + 1, credential, token);
    }
  }

  /**
   *
   * @params attempts number of attempts
   * @param credential credential of user
   * @param fcmToken fcm token
   */
  static _doSignOut (attempts, credential, fcmToken) {
    if (attempts > 3) {
      return;
    }

    console.log('try to sign out with attempts: ' + attempts);
    const url = APIClient.BASE_API_URL + '/user/signOut';
    console.log('url: ' + url);
    const headers = Utils.createBasicAuthHeaders(credential);
    const params = {
      fcm_token: fcmToken,
    };
    fetch(url, {
      method: 'POST',
      headers: headers,
      body: Utils.createBodyParams(params),
    }).then((response) => response.json()).then((json) => {
      UserUtils._handleSignOutNetworkResponse(attempts, credential, fcmToken,
        json, null);
    }).catch((error) => {
      UserUtils._handleSignOutNetworkResponse(attempts, credential, fcmToken,
        null, error);
    });
  }

  static _handleSignOutNetworkResponse (
    attempts, credential, token, response, error) {
    /*if (response) {
      console.log(response);
    }
    if (error) {
      console.error(error);
    }*/

    if (response && response.response) {
      console.log('sign out successfully');
    } else {
      UserUtils._doSignOut(attempts + 1, credential, token);
    }
  }

  /**
   * reset notification count for user
   *
   * @param attempts number of attempt
   * @param credential credential of user
   */
  static _doResetNotificationCount (attempts, credential) {
    if (attempts > 3) {
      return;
    }

    console.log('try to reset notification count with attempts: ' + attempts);
    const url = APIClient.BASE_API_URL + '/user/updateNotificationCount';
    console.log('url: ' + url);
    const headers = Utils.createBasicAuthHeaders(credential);
    const params = {
      notification_count: 0,
    };
    fetch(url, {
      method: 'POST',
      headers: headers,
      body: Utils.createBodyParams(params),
    }).then((response) => response.json()).then((json) => {
      UserUtils._handleResetNotificationCountNetworkResponse(attempts,
        credential, json, null);
    }).catch((error) => {
      UserUtils._handleResetNotificationCountNetworkResponse(attempts,
        credential, null, error);
    });
  }

  static _handleResetNotificationCountNetworkResponse (
    attempts, credential, response, error) {
    /*if (response) {
      console.log(response);
    }
    if (error) {
      console.error(error);
    }*/

    if (response && response.response) {
      console.log('reset notification count successfully');
      modules.FCM.setBadgeNumber(0);
    } else {
      UserUtils._doResetNotificationCount(attempts + 1, credential);
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/UserUtils.js